<template>
  <div>
    <b-row>
      <!-- เกร์ความเร็วเฉลี่ย -->
      <b-col
        lg="6"
        class="mb-1"
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 739 422"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M681.088 420.369H681.089H738.5V393.716V366.563V214.394V62.2252V27.5354L714.774 0.5H0.5V27.1528V54.3056V364.3V394.439L24.2263 421.5L681.088 420.369Z"
            stroke="#00B058"
          />
          <path
            d="M54 420H24.6821L2 397V371"
            stroke="#00B058"
            stroke-width="4"
          />
          <path
            d="M685 2H714.318L737 25V51"
            stroke="#00B058"
            stroke-width="4"
          />
          <foreignObject
            x="25"
            y="30"
            width="300"
            height="150"
            color="#ffffff"
            font-size="20"
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="9.927"
                y="23.7734"
                width="11.5617"
                height="2.07644"
                rx="1"
                fill="url(#paint0_linear_587_17856)"
              />
              <rect
                x="8"
                y="27.9219"
                width="15.4156"
                height="2.07644"
                rx="1"
                fill="url(#paint1_linear_587_17856)"
              />
              <path
                d="M15.1433 17.9233C15.8958 17.1124 22.6374 12.7844 22.6374 12.7844C22.6374 12.7844 18.6209 20.049 17.8684 20.8599C17.1159 21.6708 15.8958 21.6708 15.1433 20.8599C14.3908 20.049 14.3908 18.7342 15.1433 17.9233Z"
                fill="url(#paint2_linear_587_17856)"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.08928 10.3665C4.68764 5.63296 9.46281 2.35451 15 2V6.75901C10.7214 7.14412 7.11751 9.97683 5.49411 13.9014L2.08928 10.3665ZM25.1166 11.4229C23.2188 8.82112 20.3115 7.05698 17 6.75899V2C21.7573 2.30458 25.9522 4.76748 28.6873 8.45715L25.1166 11.4229ZM26.5382 13.9797C27.1117 15.3943 27.4287 16.9485 27.4287 18.5796C27.4287 21.8134 26.1826 24.7451 24.1618 26.8853H29.8595C31.2209 24.442 32 21.6052 32 18.5796C32 15.8219 31.3528 13.2212 30.2074 10.9322L26.5382 13.9797ZM0 18.5796C0 21.6052 0.779145 24.442 2.14049 26.8853H7.83844C5.8176 24.7451 4.57153 21.8134 4.57153 18.5796C4.57153 17.7931 4.64524 17.0245 4.78586 16.2808L1.11645 12.4711C0.39593 14.3619 0 16.4227 0 18.5796Z"
                fill="url(#paint3_linear_587_17856)"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_587_17856"
                  x1="15.7079"
                  y1="23.7734"
                  x2="15.7079"
                  y2="25.8499"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FFDB5E" />
                  <stop
                    offset="0.508333"
                    stop-color="#FFB54B"
                  />
                </linearGradient>
                <linearGradient
                  id="paint1_linear_587_17856"
                  x1="15.7078"
                  y1="27.9219"
                  x2="15.7078"
                  y2="29.9983"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FFDB5E" />
                  <stop
                    offset="0.508333"
                    stop-color="#FFB54B"
                  />
                </linearGradient>
                <linearGradient
                  id="paint2_linear_587_17856"
                  x1="21.5"
                  y1="13.9117"
                  x2="13.4628"
                  y2="21.0975"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FFDB5E" />
                  <stop
                    offset="0.508333"
                    stop-color="#FFB54B"
                  />
                </linearGradient>
                <linearGradient
                  id="paint3_linear_587_17856"
                  x1="16"
                  y1="2"
                  x2="16"
                  y2="26.8853"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stop-color="#FFDB5E" />
                  <stop
                    offset="0.421644"
                    stop-color="#FFB54B"
                  />
                </linearGradient>
              </defs>
            </svg>
          </foreignObject>
          <foreignObject
            width="100%"
            height="100%"
            y="80"
            x="0"
          >
            <VueSvgGauge
              :start-angle="-90"
              :end-angle="90"
              :value="AVGSpeedDetail"
              :separator-step="7"
              :inner-radius="74"
              :min="0"
              :max="200"
              :gauge-color="[{ offset: 0, color: '#FFA82B'}, { offset: 90, color: '#FF0000'}]"
              :scale-interval="0.9"
              style="height: 210px; margin-top: 20px;"
              needleshape
              :decimals="2"
            >
              <div
                v-if="AVGSpeedDetail < 120"
                align="center"
                class="inner-text"
              >
                <span><b style="color: #FFD443;"> {{ AVGSpeedDetail }} </b>กม/ชม.</span>
              </div>
              <div
                v-else
                align="center"
                class="inner-text"
              >
                <span><b style="color: #FF0000;"> {{ AVGSpeedDetail }} </b>กม/ชม.</span>
              </div>
            </VueSvgGauge>
            <div
              class="inner-text2"
            >
              <span>0</span>
              <span class="inner-text3">200</span>
            </div>
          </foreignObject>
          <foreignObject
            x="85"
            y="30"
            width="550"
            height="250"
            color="#ffffff"
            font-size="20"
          >
            <div>
              <strong>ความเร็วเฉลี่ย</strong>
              <!-- <em>word wrap</em> -->
            </div>
          </foreignObject>
        </svg>
      </b-col>

      <!-- กราฟโดนัท สัดส่วนเหตุการณ์ต่างๆ -->
      <b-col
        lg="6"
        md="12"
        xs="12"
      >
        <b-col>
          <b-card style="background-color: rgb(255, 127, 96, 0.0); width: 100%; height: 100%; border: 2px solid #00B058; border-radius: 40px 4px 40px 4px;">
            <div>
              <span style="font-size:20px; font-weight: 600; color: #fff;">สัดส่วนเหตุการณ์ต่างๆ</span>
            </div>

            <div class="pie-text text-center">
              <h3 class="font-weight-bold">
                โดยรวม
              </h3>
              <h2 class="font-weight-bolder">
                {{ Total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }}
              </h2>
            </div>
            <div class="chart">
              <app-echart-doughnut
                style="width:auto; height:350px; margin-left: -130px;"
                :series="series"
              />
            </div>
            <div class="pie-text1 text-center">
              <div
                v-for="(data,index) in series[0].data"
                :key="index"
                class="d-flex justify-content-between"
              >
                <div class="series-info">
                  <feather-icon
                    icon="CircleIcon"
                    size="16"
                    class="mr-50"
                    :style="{color: data.iconColor, fill: data.iconColor}"
                  />
                  <span>{{ data.name }}</span>
                </div>
                <span :style="{color: data.iconColor}">{{ data.percent }} %</span>
              </div>
            </div>
          </b-card>

        </b-col>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard,
} from 'bootstrap-vue'
// import AppEchartGauge from '@core/components/charts/echart/AppEchartGauge.vue'
import { VueSvgGauge } from 'vue-svg-gauge'
import axios from '@axios'
import AppEchartDoughnut from './AppEchartDoughnut.vue'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    // BCard,
    // AppEchartGauge,
    VueSvgGauge,
    AppEchartDoughnut,
  },
  data() {
    return {
      AVGSpeedDetail: 0,

      AVGSpeed: 0,
      Total: 0,
      series: [
        {
          color: ['#FFD22B', '#FF812C', '#00FFAB', '#579BFE'],
          name: 'เหตุการณ์',
          type: 'pie',
          radius: ['50%', '70%'],
          avoidLabelOverlap: true,
          label: {
            show: true,
            fontSize: '14',
            formatter: ' {b}: {c} ',
          },
          labelLine: {
            show: true,
          },
          data: [
            {
              value: '', name: 'รถจอด/อุบัติเหตุ', iconColor: '#FFD22B', percent: '',
            },
            {
              value: '', name: 'รถย้อนศร', iconColor: '#FF812C', percent: '',
            },
            {
              value: '', name: 'รถบรรทุกเลนขวา', iconColor: '#00FFAB', percent: '',
            },
            {
              value: '', name: 'รถขับเร็ว/ช้าเลนขวา', iconColor: '#579BFE', percent: '',
            },
          ],
        },
      ],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  beforeDestroy() {
    clearInterval(this.interval)
  },
  created() {
    this.interval = setInterval(() => {
      this.getAVGSpeedDetail()
      this.getPieData()
    }, 10000)
  },
  mounted() {
    this.getAVGSpeedDetail()
    this.getPieData()
  },
  methods: {

    getAVGSpeedDetail() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getStaticAIDetail-G', { wid: this.$route.query.wid })
          .then(response => {
            this.AVGSpeedDetail = response.data[1][0].countNum
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getStaticAIDetail', { wid: this.$route.query.wid })
          .then(response => {
            this.AVGSpeedDetail = response.data[1][0].countNum
          })
          .catch(error => {
            console.log(error)
          })
      }
    },

    getPieData() {
      if (this.$route.query.type !== '0') {
        axios
          .post('/getCheckTypeAITotal-G', { wid: this.$route.query.wid })
          .then(response => {
          // eslint-disable-next-line prefer-destructuring
            this.series[0].data[0].value = response.data[0][0].Total
            this.series[0].data[1].value = response.data[5][0].Total
            this.series[0].data[2].value = response.data[4][0].Total
            this.series[0].data[3].value = response.data[1][0].Total + response.data[2][0].Total + response.data[3][0].Total
            this.Total = response.data[0][0].Total + response.data[5][0].Total + response.data[4][0].Total + (response.data[1][0].Total + response.data[2][0].Total + response.data[3][0].Total)

            this.series[0].data[0].percent = parseFloat((response.data[0][0].Total / this.Total) * 100).toFixed(2)
            this.series[0].data[1].percent = parseFloat((response.data[5][0].Total / this.Total) * 100).toFixed(2)
            this.series[0].data[2].percent = parseFloat((response.data[4][0].Total / this.Total) * 100).toFixed(2)
            this.series[0].data[3].percent = parseFloat(((response.data[1][0].Total + response.data[2][0].Total + response.data[3][0].Total) / this.Total) * 100).toFixed(2)
            if (response.data[0][0].Total === 0 && response.data[5][0].Total === 0 && response.data[4][0].Total === 0
           && response.data[1][0].Total === 0 && response.data[2][0].Total === 0 && response.data[3][0].Total === 0) {
              this.series[0].data[0].percent = 0
              this.series[0].data[1].percent = 0
              this.series[0].data[2].percent = 0
              this.series[0].data[3].percent = 0
            }
          // eslint-disable-next-line prefer-destructuring
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        axios
          .post('/getCheckTypeAITotal', { wid: this.$route.query.wid })
          .then(response => {
          // eslint-disable-next-line prefer-destructuring
            this.series[0].data[0].value = response.data[0][0].Total
            this.series[0].data[1].value = response.data[5][0].Total
            this.series[0].data[2].value = response.data[4][0].Total
            this.series[0].data[3].value = response.data[1][0].Total + response.data[2][0].Total + response.data[3][0].Total
            this.Total = response.data[0][0].Total + response.data[5][0].Total + response.data[4][0].Total + (response.data[1][0].Total + response.data[2][0].Total + response.data[3][0].Total)

            this.series[0].data[0].percent = parseFloat((response.data[0][0].Total / this.Total) * 100).toFixed(2)
            this.series[0].data[1].percent = parseFloat((response.data[5][0].Total / this.Total) * 100).toFixed(2)
            this.series[0].data[2].percent = parseFloat((response.data[4][0].Total / this.Total) * 100).toFixed(2)
            this.series[0].data[3].percent = parseFloat(((response.data[1][0].Total + response.data[2][0].Total + response.data[3][0].Total) / this.Total) * 100).toFixed(2)
            if (response.data[0][0].Total === 0 && response.data[5][0].Total === 0 && response.data[4][0].Total === 0
           && response.data[1][0].Total === 0 && response.data[2][0].Total === 0 && response.data[3][0].Total === 0) {
              this.series[0].data[0].percent = 0
              this.series[0].data[1].percent = 0
              this.series[0].data[2].percent = 0
              this.series[0].data[3].percent = 0
            }
          // eslint-disable-next-line prefer-destructuring
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
  },
}
</script>

<style lang="scss">
  .text1 {
    position: absolute;
    font-family: Arial;
    top: 20px;
    right: 20px;
    color: white;
  }
.progress1 .progress-bar{background: #579BFE;}
.progress2 .progress-bar{background: #DC48FF;}
.progress3 .progress-bar{background: #8246FE;}
.progress4 .progress-bar{background: #FE447A;}
.progress5 .progress-bar{background: #4EAF51;}
.progress6 .progress-bar{background: #FF805D;}
.progress7 .progress-bar{background: #FDFF01;}

.inner-text {

  display: flex;
  justify-content: center;
  margin-top: 75px;
  font-size: 20px;
  color: #FFFFFF;
  font-weight: bold;
}
.inner-text2 {
margin-left: 220px;
font-size: 44px;
color: #FFB54B;
font-weight: bold;
}
.inner-text3 {
margin-left: 270px;
font-size: 44px;
color: #FFB54B;
font-weight: bold;
}

.pie-text{
      width: 105px;
      position:absolute;
      margin: auto;
      left: 10%;
      right: 27%;
      top: 45%;
      bottom: 0;
    }
    .pie-text1{
      width: 200px;
      position:absolute;
      margin: auto;
      left: 70%;
      right: 0;
      top: 25%;
      bottom: 0;
    }
</style>
